import { Container, Grid, Paper } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Investigador } from "../../../Interface/IInvestigadorUnidad";
import { I18nContext } from "../../../I18nProvider";
import { useContext } from "react";

export interface InvestigadorProps {
    investigadores: Investigador[];
    page: number;
    totalRows: number;
    setPage: (page: number) => void;
}

export const InvestigadoresUnidad: React.FC<InvestigadorProps> = ({
    investigadores,
    page,
    totalRows,
    setPage,
}) => {
    const navigate = useNavigate();
    const context = useContext(I18nContext);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }


    const columns: GridColDef[] = [
        { field: "scopus", headerName: "Scopus ID", flex: 0.3, sortable: false, resizable: false },
        { field: "investigador", headerName: context.t.translate("investigador.investigador"), flex: 0.7, sortable: false, resizable: false },
    ];

    const rows = investigadores.map((investigador) => ({
        id: investigador.scopusId,
        scopus: investigador.scopusId,
        investigador: investigador.nombreCompleto,
    }));

    const handleRowClick = (params: any) => {
        const { id } = params.row;
        navigate(`/investigador/${id}`);
    };

    return (
        <Container>
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8} md={8}>
                    <Paper elevation={3} style={{ width: "100%", height: 400 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            onRowClick={handleRowClick}
                            pageSizeOptions={[25]} 
                            paginationMode="server"
                            rowCount={totalRows}
                            paginationModel={{ page: page - 1, pageSize: 25 }} 
                            onPaginationModelChange={(model) => setPage(model.page + 1)} 
                            disableColumnMenu
                            sx={{
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: "blue !important",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                },
                                "& .MuiDataGrid-cell": {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                                "& .MuiDataGrid-row:hover": {
                                    cursor: "pointer",
                                    backgroundColor: "#f5f5f5",
                                },
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};
